import Image from "next/image";
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import EmphasizedText from "@/components/EmphasizedText";
import type { HeroProps } from "../types";

const DefaultHero = ({
  title,
  titleOverride,
  children,
  image,
  path,
  hasBreadcrumbs = true,
  slant = false,
  stringToEmphasize,
  mb = "mb-6",
}: HeroProps) => {
  return (
    <div className={`bg-primary not-prose mx-break-out ${mb}`}>
      <div className="grid grid-cols-3 container">
        <div className="col-span-3 md:col-span-2 pb-12 pt-20 md:pt-16">
          {hasBreadcrumbs && path && (
            <Breadcrumbs variant="light" path={path} />
          )}
          <h1 className="text-[52px] leading-[56px] lg:text-6xl text-white font-bold mb-6 p-0 pt-2 mt-0">
            <EmphasizedText
              text={titleOverride || title}
              textEmphasis={stringToEmphasize}
            />
          </h1>
          <div className="[&>*]:text-white [&>p]:text-lg text-primary-foreground">
            {children ?? null}
          </div>
        </div>

        {image?.sourceUrl && (
          <div className="hidden md:block relative mr-break-out">
            <Image
              fill={true}
              priority={true}
              src={image.sourceUrl}
              alt={image.altText ?? "hero"}
              className={`object-cover ${slant ? "clip-slant-left" : ""}`}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DefaultHero;
